import styled from '@emotion/styled';
import { Avatar as _Avatar, Typography } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { ClassAttributes, createElement } from 'react';

import { User } from '../../../graphql/generated/graphql';
import { SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';

interface Props {
  user: Pick<User, 'profileImageUrl' | 'name'>;
  size?: number;
  variant?: Variant;
  className?: string;
}

const AvatarAndName = ({ user, size = 24, variant = 'body1', className }: ClassAttributes<HTMLElement> & Props) => {
  const avatarStyle = {
    width: size,
    height: size,
  };
  const avatar = user.profileImageUrl ? (
    <Avatar src={user.profileImageUrl} alt={user.name} style={avatarStyle} />
  ) : (
    <AccountCircle style={avatarStyle} color="action" />
  );
  return (
    <Root className={className}>
      {avatar}
      <Name variant={variant} noWrap>
        {user.name}
      </Name>
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['auto', '1fr'],
    rows: ['auto'],
    areas: [['avatar', 'name']],
  }),
);

const Avatar = styled(_Avatar)(gridLayoutItem('avatar'));

const Name = styled(Typography)(
  gridLayoutItem('name', {
    alignSelf: 'center',
  }),
  {
    marginLeft: SPACING_UNIT,
  },
);

export default AvatarAndName;
